import * as mutationTypes from './mutationTypes'

export default {
  [mutationTypes.SET_APPLICATION_LIST_LOADING](state, loading) {
    state.applicationListLoading = loading
  },
  [mutationTypes.SET_APPLICATION_LIST](state, payload) {
    state.applicationListLoading = false
    if (Array.isArray(payload)) {
      state.applicationList = payload
    } else {
      state.applicationList = []
      state.applicationListMessage = payload.userMessage
    }
  },
  [mutationTypes.SET_RECIPIENTS_LIST_LOADING](state, loading) {
    state.recipientsListLoading = loading
  },

  [mutationTypes.SET_RECIPIENTS_LIST](state, payload) {
    state.recipientsListLoading = false
    if (Array.isArray(payload)) {
      state.recipientsList = payload
    } else {
      state.recipientsList = []
    }
  },

  [mutationTypes.UPDATE_RECIPIENTS_LIST](state) {
    let rList = state.recipientsList
    rList.map((item, index) => {
      item.routingOrder = index + 2
    })
    state.recipientsList = rList
  },

  [mutationTypes.SWAP_RECIPIENTS_LIST](state, payload) {
    let rList = state.recipientsList
    const oldValueIndex = rList.findIndex(
      r => Number(r.routingOrder) == Number(payload.oldPosition)
    )
    const newValueIndex = rList.findIndex(
      r => Number(r.routingOrder) == Number(payload.newPosition)
    );
    [rList[oldValueIndex], rList[newValueIndex]] = [
      rList[newValueIndex],
      rList[oldValueIndex]
    ]
    rList.map((item, index) => {
      item.routingOrder = index + 2
    })
    state.recipientsList = rList
  },

  [mutationTypes.SET_ADD_RECIPIENT](state, payload) {
    let rList = state.recipientsList
    const maxRoutingNumber = 1 + Math.max(...rList.map(o => o.routingOrder), 0)
    let recipient = {
      applicationId: payload.applicationId || '',
      recipientUuid: payload.recipientUuid || '',
      recipientKey: payload.recipientKey || '',
      name: payload.name || '',
      email: payload.email || '',
      envelopeId: payload.envelopeId || '',
      dsRecipientId: payload.dsRecipientId || '',
      routingOrder: payload.routingOrder || maxRoutingNumber,
      completedDate: payload.completedDate || null
    }
    rList = [...rList, recipient]
    state.recipientsList = rList
  },

  [mutationTypes.SET_REMOVE_RECIPIENT](state, payload) {
    let rList = state.recipientsList
    rList = rList.filter((r, i) => i !== payload.index)
    rList.map((item, index) => {
      item.routingOrder = index + 2
    })
    state.recipientsList = rList
  },

  [mutationTypes.SET_RECIPIENTS_LIST_TO_ORIGINAL](state) {
    state.recipientsList = JSON.parse(JSON.stringify(state.originalRecipientsList))
  },

  [mutationTypes.SET_ORIGINAL_RECIPIENTS_LIST](state, payload) {
    if (Array.isArray(payload)) {
      state.originalRecipientsList = payload
    } else {
      state.originalRecipientsList = []
    }
  },
  [mutationTypes.MAKE_BATCH_CALL_LOADING](state, payload) {
    state.batchLoading = payload
  },
  [mutationTypes.SET_RESEND_EMAIL_LOADING](state, payload) {
    state.resendEmailLoading = payload
  },
  [mutationTypes.SET_RESEND_EMAIL](state, payload) {
    let aList = state.applicationList
    let item = aList.find(a => a.applicationId === payload.applicationId)
    item['emailLastSentDate'] = payload.emailLastSentDate
    state.applicationList = aList
  }

}
